var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 2.3332H2.5C2.03587 2.3332 1.59075 2.50879 1.26256 2.82135C0.934374 3.13391 0.75 3.55784 0.75 3.99986V15.6665C0.75 16.1086 0.934374 16.5325 1.26256 16.845C1.59075 17.1576 2.03587 17.3332 2.5 17.3332H14.75C15.2141 17.3332 15.6592 17.1576 15.9874 16.845C16.3156 16.5325 16.5 16.1086 16.5 15.6665V9.8332M15.1875 1.0832C15.5356 0.751676 16.0077 0.56543 16.5 0.56543C16.9923 0.56543 17.4644 0.751676 17.8125 1.0832C18.1606 1.41472 18.3562 1.86436 18.3562 2.3332C18.3562 2.80204 18.1606 3.25168 17.8125 3.5832L9.5 11.4999L6 12.3332L6.875 8.99986L15.1875 1.0832Z",
    stroke: "#06513D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.d8b94277d17fbce4aaef73ff97b66815.svg";
export { ForwardRef as ReactComponent };